module.exports = __webpack_public_path__ + "static/media/robert_carrey.96a73993.jpg";